import { render } from "./icon-approve.vue?vue&type=template&id=3a61a2c5"
import script from "./icon-approve.vue?vue&type=script&lang=js"
export * from "./icon-approve.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__